import { sendbirdSelectors, useSendbirdStateContext } from '@sendbird/uikit-react';
import GroupChannelHandler from '@sendbird/uikit-react/handlers/GroupChannelHandler';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { config } from '_config';
import { getCountOfUnread } from '_store/chat/slice';
import { selectCustomerId } from '_store/user/selector';

export default function SendbirdSubscription() {
  const dispatch = useDispatch();
  const customerId = useSelector(selectCustomerId);
  const context = useSendbirdStateContext();
  const sdk = sendbirdSelectors.getSdk(context);

  useEffect(() => {
    if (sdk && sdk.groupChannel?.addGroupChannelHandler && customerId) {
      const channelHandler = new GroupChannelHandler();

      channelHandler.onChannelChanged = () => {
        dispatch(getCountOfUnread({ customerId }));
      };

      sdk.groupChannel.addGroupChannelHandler(config.sendbirdAppId, channelHandler);
    }

    return () => {
      if (sdk && sdk.groupChannel?.removeGroupChannelHandler) {
        sdk.groupChannel.removeGroupChannelHandler(config.sendbirdAppId);
      }
    };
  }, [sdk, customerId]);

  return null;
}
